// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Grid,
//   Button,
//   Typography,
//   TextField,
//   CircularProgress,
// } from '@mui/material';
// import style from '../Tools/Style';
// import { useStateValue } from '../../contexto/store';
// import { Search } from '@mui/icons-material';
// import { obtenerTodasLasEncuestas } from '../../actions/EncuestaAction';
// import TEncuestas from './TEncuestas';

// export default function MisEncuestas(props) {
//   //eslint-disable-next-line
//   const [{ sesionUsuario }, distpatch] = useStateValue();
//   const [term, setTerm] = useState('');
//   const [Datae, setDatae] = useState([]);
//   const [datosCargados, setDatosCargados] = useState(false);

//   const irANuevaEncuesta = () => {
//     props.history.push('/nuevaEncuesta');
//   };

//   useEffect(() => {
//     setDatosCargados(false);
    
//     obtenerTodasLasEncuestas().then((response) => {
//       if (response.status === 200) {
//         setDatae(response.data);
//         setDatosCargados(true); // Para no dejar cargando infinitamente
//       } else {
//         console.log('ERROR EN OBTENER ENCUESTAS');
//       }
//     });
//   }, []);

//   return (
//     <Container maxWidth="lg">
//       <br />
//       <Typography align="center" variant="h6">
//         Mis Encuestas
//       </Typography>
//       <Grid container direction="row" justify="flex-start">
//         <Grid item lg={12} md={12} sm={12} xs={12}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={irANuevaEncuesta}
//           >
//             Nueva Encuesta
//           </Button>
//         </Grid>
//       </Grid>
//       <Grid container direction="row">
//         <Grid item lg={12} md={12} xs={12} sm={12}>
//           <br />
//           <Search style={{ fontSize: 40, marginTop: 5 }} />
//           <TextField
//             style={style.Selectrol}
//             variant="outlined"
//             onChange={(e) => setTerm(e.target.value)}
//             label=" Buscar"
//             placeholder="Buscar por título, descripción o codigo de encuesta"
//           />
//         </Grid>
//       </Grid>
//       <Grid item lg={12} md={12} sm={12} xs={12}>
//         {datosCargados ? (
//           <TEncuestas rows={Datae} termp={term} />
//         ) : (
//           <Grid container justify="center">
//             <CircularProgress />
//             <br />
//             <Typography>Cargando...</Typography>
//           </Grid>
//         )}
//       </Grid>
//     </Container>
//   );
// }
import React, { useState, useEffect } from 'react';
import {
  Container,
  Button,
  Typography,
  TextField,
  CircularProgress,
  Paper,
  Box,
  InputAdornment,
  Chip
} from '@mui/material';
import { useStateValue } from '../../contexto/store';
import { Search, AddCircleOutline, Assessment } from '@mui/icons-material';
import { obtenerTodasLasEncuestas } from '../../actions/EncuestaAction';
import TEncuestas from './TEncuestas';

export default function MisEncuestas(props) {
  //eslint-disable-next-line
  const [{ sesionUsuario }, distpatch] = useStateValue();
  const [term, setTerm] = useState('');
  const [Datae, setDatae] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);

  const irANuevaEncuesta = () => {
    props.history.push('/nuevaEncuesta');
  };

  const cargarEncuestas = async () => {
    setDatosCargados(false);
    try {
      const response = await obtenerTodasLasEncuestas();
      if (response.status === 200) {
        setDatae(response.data);
        setDatosCargados(true);
      } else {
        console.log('ERROR EN OBTENER ENCUESTAS');
        setDatosCargados(true); // Para no dejar cargando infinitamente
      }
    } catch (error) {
      console.error('Error al cargar encuestas:', error);
      setDatosCargados(true);
    }
  };

  useEffect(() => {
    cargarEncuestas();
  }, []);

  // Filtrar del estado actual
  const handleEncuestaEliminada = (encuestaId) => {
    setDatae(prevEncuestas => 
      prevEncuestas.filter(encuesta => encuesta.encuestaId !== encuestaId)
    );
  };


  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header moderno con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
              }}
            >
              <Assessment sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
                Gestión de Encuestas
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip 
                  label={`${Datae.length} encuesta${Datae.length === 1 ? '' : 's'} registrada${Datae.length === 1 ? '' : 's'}`}
                  size="small"
                  sx={{ 
                    backgroundColor: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    fontWeight: 500,
                    backdropFilter: 'blur(10px)',
                  }}
                />
              </Box>
            </Box>
          </Box>
          
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={irANuevaEncuesta}
            sx={{
              backgroundColor: 'white',
              color: '#0d47a1',
              fontWeight: 600,
              px: 3,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.9)',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Nueva Encuesta
          </Button>
        </Box>
      </Paper>

      {/* Barra de búsqueda moderna */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por título, descripción o código de encuesta..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.default',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Tabla de encuestas */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          <TEncuestas 
            rows={Datae} 
            termp={term} 
            onEncuestaEliminada={handleEncuestaEliminada} 
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <Typography variant="h6" color="text.secondary">
              Cargando encuestas...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}